module.exports = __webpack_public_path__ + "static/media/newvision.62559baf.png";